// ---------------------------------------------------------------------------
// After-hours "See a Provider Now" support (§6). The after-hours profile is
// hidden from the normal service grid and offered only via a top banner, and
// only while the current practice-local (Central) time is inside its window.
// ---------------------------------------------------------------------------

import type { AppConfig, Profile } from './types'
import { nowCentralHHmm } from './dates'

/** The (first) after-hours profile in the config, if any. */
export function findAfterHoursProfile(config: AppConfig): Profile | null {
  return config.profiles.find((p) => p.after_hours) ?? null
}

function toMinutes(hhmm: string): number {
  const [h, m] = hhmm.split(':').map(Number)
  return h * 60 + m
}

/**
 * Whether the after-hours banner should be visible right now. With no window
 * configured it's always available; otherwise the current Central time must fall
 * inside [start, end), where end < start means the window wraps past midnight.
 */
export function isAfterHoursOpen(profile: Profile | null, now: string = nowCentralHHmm()): boolean {
  if (!profile?.after_hours) return false
  const win = profile.after_hours_window
  if (!win) return true
  const start = toMinutes(win.start)
  const end = toMinutes(win.end)
  const cur = toMinutes(now)
  return start <= end ? cur >= start && cur < end : cur >= start || cur < end
}
